import axiosClient from "./axiosClient";

function readItems(payload) {
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  return [];
}

function normalizeBusiness(item) {
  const id = item?.id || item?.businessId || item?.BusinessId;
  return {
    id,
    name:
      item?.businessName ||
      item?.BusinessName ||
      item?.companyName ||
      item?.CompanyName ||
      item?.name ||
      "Unnamed Business",
    email: item?.businessEmail || item?.BusinessEmail || item?.ownerEmail || "",
    planId: item?.planId || item?.PlanId || null,
    planName: item?.planName || item?.PlanName || item?.plan || item?.Plan || "",
    status: item?.status || item?.Status || "",
  };
}

function normalizeBusinessUser(item) {
  const id = item?.id || item?.userId || item?.UserId;
  return {
    id,
    businessId: item?.businessId || item?.BusinessId || null,
    name:
      item?.name ||
      item?.fullName ||
      item?.displayName ||
      item?.Name ||
      item?.FullName ||
      item?.DisplayName ||
      "",
    email: item?.email || item?.Email || "",
    roleId: item?.roleId || item?.RoleId || null,
    roleName: item?.roleName || item?.RoleName || item?.role || item?.Role || "",
    status: item?.status || item?.Status || "",
  };
}

export async function getApprovedBusinessesForUserOverrides() {
  const { data } = await axiosClient.get("/businesses/approved", {
    __silentToast: true,
    __silent401: true,
    __silent403: true,
    __skipBizHeader: true,
  });

  return readItems(data)
    .map(normalizeBusiness)
    .filter(item => !!item.id);
}

export async function getBusinessUsers(businessId) {
  if (!businessId) {
    throw new Error("getBusinessUsers: businessId is required");
  }

  const { data } = await axiosClient.get(
    `/admin/businesses/${encodeURIComponent(businessId)}/users`,
    {
      __silentToast: true,
      __silent401: true,
      __silent403: true,
      __skipBizHeader: true,
    }
  );

  return readItems(data)
    .map(normalizeBusinessUser)
    .filter(item => !!item.id);
}

const usersApi = {
  getApprovedBusinessesForUserOverrides,
  getBusinessUsers,
};

export default usersApi;
